<template>
  <div>
    <v-container v-if="!finished" class="v-question">
      <v-row align="center" justify="center">
        <v-col cols="12" sm="12" md="12" lg="6">
          <v-card v-if="question">
            <v-card-text class="justify-center">
              <div class="v-img mb-5">
                <img id="image1" width="100%" ref="image1" v-show="showImage1" :src="image1"
                     @load="image1Loaded = true">
                <img v-if="image1Loaded" id="image2" width="100%" ref="image2" v-show="showImage2" :src="image2">
                <div class="text-center" style="width: 100%">
                  <v-progress-circular v-if="!image1Loaded" :width="3" color="primary"
                                       indeterminate></v-progress-circular>
                </div>
              </div>
              <v-row align="center">
                <v-col cols="6" class="text-center">
                  <v-btn :color="btnColor(0)" dark x-large block
                         @click="responseButton(0)"
                         :class="buttonsDisabled ? 'btn-disabled' : ''"
                  >{{
                    this.question.options[0]['title'] }}
                  </v-btn>
                </v-col>
                <v-col cols="6" class="text-center">
                  <v-btn :color="btnColor(1)" dark x-large block @click="responseButton(1)"
                         :class="buttonsDisabled ? 'btn-disabled' : ''">{{
                    this.question.options[1]['title'] }}
                  </v-btn>
                </v-col>
                <v-col cols="6" class="text-center">
                  <v-btn :color="btnColor(2)" dark x-large block
                         @click="responseButton(2)"
                         :class="buttonsDisabled ? 'btn-disabled' : ''"
                  >{{
                    this.question.options[2]['title'] }}
                  </v-btn>
                </v-col>
                <v-col cols="6" class="text-center">
                  <v-btn :color="btnColor(3)" dark x-large block
                         @click="responseButton(3)"
                         :class="buttonsDisabled ? 'btn-disabled' : ''"
                  >{{
                    this.question.options[3]['title'] }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
            <v-bottom-navigation background-color="secondary" height="75" dark fixed>
              <v-row align="center" justify="center" class="text-center">
                <v-col cols="2" v-for="index in 4" :key="'life-' + index">
                  <v-img :src="imagePath('logo-'+ index,'png')"
                         width="100"
                         :class="index > life ? 'v-gray' : ''"
                  ></v-img>
                </v-col>
              </v-row>
            </v-bottom-navigation>
          </v-card>
        </v-col>
      </v-row>
      <v-snackbar v-model="dialog" top color="white" class="pa-0">
        <div v-if="answerIsCorrect === true">
          <v-alert color="success" class="mb-0">
            پاسخ شما درست می باشد.
          </v-alert>
        </div>
        <div v-else-if="answerIsCorrect === false">
          <v-alert color="error" class="mb-0">
            پاسخ شما غلط می باشد.
          </v-alert>
        </div>
      </v-snackbar>
    </v-container>
    <v-container v-else class="v-question">
      <v-row align="center" justify="center">
        <v-col cols="12" sm="12" md="12" lg="8">
          <v-card elevation="3">
            <v-card-title class="justify-center text-center">
              امتیاز شما
              <strong class="v-score pt-3" >{{ score }}</strong>
            </v-card-title>
            <v-card-text v-if="userScoreData" class="justify-center text-center">
              رکورد شما : <strong>{{ userScoreData.score }}</strong>
            </v-card-text>
            <v-card-text>
              <v-simple-table v-if="topScores" class="text-center">
                <template v-slot:default>
                  <thead>
                  <tr>
                    <th class="text-center">
                      رتبه
                    </th>
                    <th class="text-center">
                      نام کاربری
                    </th>
                    <th class="text-center">
                      امتیاز کاربر
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(row,index) in topScores"
                      :key="index"
                      :class="isUserTopRank(index+1) ? 'user-rank-row' : ''"
                  >
                    <td>{{ index+1 }}</td>
                    <td>{{ row.name }}</td>
                    <td>{{ row.score }}</td>
                  </tr>
                  <tr v-if="userScoreRow">
                    <td>...</td>
                    <td>...</td>
                    <td>...</td>
                  </tr>
                  <tr v-if="userScoreRow" class="v-user">
                    <td>{{ userScoreData.rank }}</td>
                    <td>{{ userScoreData.name }}</td>
                    <td>{{ userScoreData.score }}</td>
                  </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <div v-else class="text-center" style="width:100%">
                <v-progress-circular indeterminate color="primary"></v-progress-circular>
              </div>
            </v-card-text>
          </v-card >

          <v-card v-if="price" class="mt-3" color="amber lighten-3">
            <v-card-title class="justify-center text-center">جایزه شما</v-card-title>
            <v-card-text class="justify-center text-center">
              <p>{{ price.text }}</p>
              <strong v-if="price.value"
                      class="coupon-code"
                      v-clipboard:copy="price.value"
                      v-clipboard:success="onCopy"
                      v-clipboard:error="onError"
              >
                <span>{{ price.value }}</span>
                <v-icon color="primary">mdi-content-copy</v-icon>
              </strong>

              <p v-if="price.value" class="navigate-to-courses"><a href="https://shootshot.com/courses/" target="_blank">
                بفرمایید داخل، دم در بده! :) اگه میخوای از کد تخفیفت استفاده کنی، ما مستقیم می‌بریمت تو بخش دوره‌های آموزشی. کوله بارتو ببند و همراه ما بیا...
              </a>
              </p>

            </v-card-text>
          </v-card>

        </v-col>
      </v-row>
      <v-bottom-navigation background-color="secondary" height="75" dark fixed>
        <v-btn class="retry-button" to="/" text dark block>
          دوباره می خواهید بازی کنید؟
        </v-btn>
      </v-bottom-navigation>
    </v-container>
  </div>
</template>
<script>
    import {mapState, mapGetters, mapActions} from "vuex";

    export default {
        name: 'game',
        data: function () {
            return {
                image1Loaded: false,
                showTopImage: true,
                dialog: false,
            }
        },
        watch: {
            answerIsCorrect(val) {
                this.dialog = val !== null;
            },
            finished(val) {
                if (val) {
                    this.updateSettings({
                        key: 'starterQuestions',
                        value: null,
                    });
                }
            }
        },
        computed: {
            ...mapState('game', [
                'selectedPhotographerId',
                'life',
                'score',
                'topScores',
                'userScoreData',
                'price',
                'finished',
            ]),
            ...mapGetters('game', [
                'question',
                'image1',
                'image2',
                'showImage1',
                'showImage2',
                'answer',
                'answerIsCorrect',
                'buttonsDisabled',
                'imageQueue',
            ]),
            userScoreRow() {
                return this.userScoreData !== null && this.userScoreData.rank > 20;
            },
        },
        methods: {
            ...mapActions(['updateSettings']),
            ...mapActions('snack', ['showError', 'showSuccess']),
            ...mapActions('game', [
                'nextQuestion',
                'addAnswer',
                'setSelectedPhotographerId',
                'checkAnswer'
            ]),
            async responseButton(number) {
                const self = this;
                self.imageLoaded = false;
                self.checkAnswer(number);
                setTimeout(function () {
                    self.nextQuestion();
                }, 2000);
            },
            btnColor(optionNumber) {

                const optionPhotographerId = parseInt(this.question.options[optionNumber].id);

                if (this.selectedPhotographerId === null)
                    return 'secondary';

                const selectedPhotographerId = parseInt(this.selectedPhotographerId);
                const answer = parseInt(this.answer);

                if (optionPhotographerId === answer) {
                    return 'success';
                }

                if (selectedPhotographerId === optionPhotographerId) {

                    if (answer === selectedPhotographerId) {
                        return 'success';
                    } else {
                        return 'error';
                    }
                }
                return 'secondary';
            },
            isUserTopRank(rank) {
                console.log(rank + "===" + parseInt(this.userScoreData.rank));
                return rank === parseInt(this.userScoreData.rank);
            },
            onCopy: function () {
                this.showSuccess('کد تخفیف با موفقیت کپی شد');
            },
            onError: function () {
                this.showError('مشکلی در کپی کردن به وجود آمده :(');
            }
        },
        mounted() {

        }
    }
</script>
<style scoped>
  .btn-disabled {
    pointer-events: none;
  }

  .v-img {
    height: 450px;
    display: flex;
    align-items: center;
    position: relative;
  }

  .v-img img {
    height: 100%;
    position: absolute;
    object-fit: contain;
    border-radius: .25rem;
  }

  .v-bottom-navigation .v-image {
    margin: 0 auto;
  }

  .v-bottom-navigation .row {
    flex-direction: row-reverse;
  }

  .v-bottom-navigation {
    border-radius: 0;
  }

  .retry-button {
    font-size: 1.35rem !important;
  }

  .v-bottom-navigation .v-gray {
    filter: grayscale(1);
  }

  table tr th {
    font-size: .95rem !important;
    font-weight: normal;
  }

  table tr td {
    font-size: 1rem !important;
  }

  .user-rank-row{
    background: #fbb545;
    font-weight: bold;
    color: #34495e;
  }

  .v-score {
    width: 100%;
    display: block;
    font-size: 3rem;
    color: #fbb545;
  }

  .v-user {
    font-family: 'Vazir-Black';
  }

  @media screen and (max-width: 1366px) {
    .v-question {
      padding: 30px 15px 120px;
    }
  }

  @media screen and (max-width: 576px) {
    .v-img {
      height: 250px;
    }
  }

  .coupon-code{
    background: #fff;
    padding: 5px 15px;
    border-radius: 5px;
  }

  .coupon-code > span{
    padding-left:5px;
  }

  .navigate-to-courses > a{
    color: #34495e;
  }

</style>